import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { FormGroup, Label, Input } from 'reactstrap';
import qs from 'qs';
import { format as formatDate } from 'date-fns';
import classnames from 'classnames';

import { fullPathWithParams, } from '../utils';

export default function QueryBoolean(props) {
  const { paramName, label, defaultValue, disabled = false, controlled = false, value: controlledValue, onChange: controlledOnChange, ...extraProps } = props;
  const history = useHistory();
  const location = useLocation();
  const { [paramName]: urlValue = defaultValue } = qs.parse(decodeURI(location.search.slice(1)));
  const currentValue = controlled ? controlledValue : urlValue;
  const onChange = ({ target: { checked } }) => {
    if (controlled && controlledOnChange) {
      controlledOnChange(checked ? '1' : '0');
    } else if (!controlled) {
      const path = fullPathWithParams({ [paramName]: checked ? '1' : '0' }, location);
      history.replace(encodeURI(path));
    }
  };

  return (
    <div {...extraProps}>
      <FormGroup className="m-0">
        <FormGroup check>
          <Label check>
            <Input type="checkbox" checked={currentValue === '1'} onChange={onChange} disabled={disabled} />
            {label}
          </Label>
        </FormGroup>
      </FormGroup>
    </div>
  );
};

